// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3NWAd","file":"styles_file__2EHMb"};